import { FC } from 'react';
import {
  CollectionPlaceholder,
  Container,
  FiltersTreezPlaceholder,
  Placeholder,
} from '@/components';
import style from './SpecialPlaceholder.module.scss';

const SpecialPlaceholder: FC<{ isComponent: boolean }> = ({ isComponent }) => {
  const content = (
    <Container className={style.placeholder__page_ecommerce}>
      <section className={style.placeholder__container}>
        <FiltersTreezPlaceholder />
        <Placeholder className={style.placeholder__banner} />
        <CollectionPlaceholder />
      </section>
    </Container>
  );

  if (isComponent) {
    return content;
  }

  return (
    <main id="main" role="main">
      {content}
    </main>
  );
};

export { SpecialPlaceholder };
